import { useState } from "react";
import { getOrder } from "../app/services/manager/admin/orders.service";
import { IOrderDetails } from "../app/models/IOrder";
import { useEffectOnce } from "react-use";

export const useOrderDetails = (id: string) => {
	const [order, setOrder] = useState<IOrderDetails>();
	const [orderIsLoading, setOrderIsLoading] = useState(false);

	const loadOrder = (id: string) => {
		setOrderIsLoading(true);

		getOrder(id)
			.then((response) => {
				setOrder(response);
			})
			.finally(() => {
				setOrderIsLoading(false);
			});
	};

	useEffectOnce(() => {
		loadOrder(id);
	});

	return { order, setOrder, loadOrder, orderIsLoading };
};
